import { useQuery } from '@tanstack/react-query';

import { mediaGet } from '@/shared/api/generated/media/media';
import { AuthImage } from '@/shared/ui/AuthImage';

import styles from './Catalog.module.scss';
import { PageSketch } from './Sketch';
import type { SketchKind } from './sketchOf';

/**
 * Превью страницы-записи: обложка, если она есть (статья, кейс), иначе —
 * эскиз секций, как у обычной страницы.
 */
export function Cover({ mediaId, kinds }: { mediaId?: string | undefined; kinds: SketchKind[] }) {
  const item = useQuery({
    queryKey: ['media-item', mediaId],
    enabled: mediaId !== undefined,
    queryFn: async () => {
      const response = await mediaGet(mediaId ?? '');

      if (response.status !== 200) {
        throw new Error('Неожиданный ответ на запрос файла');
      }

      return response.data;
    },
  }).data;

  if (mediaId === undefined || (item !== undefined && item.thumb_url == null)) {
    return <PageSketch kinds={kinds} />;
  }

  return (
    <div className={styles['cover']} aria-hidden="true">
      {item?.thumb_url != null && (
        <AuthImage className={styles['cover__image']} src={item.thumb_url} alt="" />
      )}
    </div>
  );
}
